module.exports = __webpack_public_path__ + "officialStatic/img/new23.58a0a80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new23.jpg
// module id = tj1p
// module chunks = 0